import {remote} from '../constants/environment';
import {IAppInfoResponse} from '../interfaces/services';

import {customFetch as fetch, remoteCall} from '../utils/services';
import {defaultHeaders} from './headers';

export const getAppInfo = async (): Promise<IAppInfoResponse> => {
  const remoteURI = remote.getAppInfoUri();
  return (await remoteCall(
    async () => {
      return await fetch(remoteURI, {
        method: 'GET',
        headers: defaultHeaders,
      });
    },
    async (response: Response) => {
      if (response.status === 201 || response.status === 200) {
        const {success, payload} = await response.json();
        return {
          success,
          payload,
        };
      }
    },
    remoteURI,
  )) as IAppInfoResponse;
};
